import { Base } from './base';
export class RegexValidator extends Base {
    constructor(fieldName, value, pattern, errorMsg) {
        super(fieldName, value);
        this.errorMsg = `"${this.getFieldname()}" has wrong chars`;
        this.pattern = pattern;
        if (errorMsg) {
            this.errorMsg = errorMsg;
        }
    }
    isValid() {
        const value = String(this.value);
        if (!this.pattern.test(value)) {
            this.errors.push(this.errorMsg);
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=regexValidator.js.map